export default __webpack_public_path__ + "static/media/lottery-banners-cn.11f5253d.webp";